import React from 'react';
import './settings.css';

export function SettingsPanel({ children, padded }) {
  return <div className={`settings-panel${padded ? ' is-padded' : ''}`}>{children}</div>;
}

export function SettingsBlock({ title, children }) {
  return (
    <div className="settings-block">
      {title ? <h3 className="settings-block-title">{title}</h3> : null}
      {children}
    </div>
  );
}

export function SettingsPageHead({ title, description }) {
  return (
    <div className="settings-page-head">
      <h2 className="settings-page-title">{title}</h2>
      {description ? <p className="settings-page-desc">{description}</p> : null}
    </div>
  );
}

export default function SettingsField({ label, help, children, stack }) {
  return (
    <div className={`settings-field-row${stack ? ' is-stack' : ''}`}>
      <div className="settings-field-copy">
        <div className="settings-field-name">{label}</div>
        {help ? <div className="settings-field-help">{help}</div> : null}
      </div>
      <div className="settings-field-control">{children}</div>
    </div>
  );
}
